import { useParams } from "react-router";
import { Loading } from "src/components/utils/Loading";
import { ANSWER_SSQ, ORGANIZATION, useFoodpilotContext } from "src/context/FoodpilotContext";
import { QuestionnaireFormContextProvider } from "src/components/QuestionnaireForm/context/provider";
import { getSsqDisplayTitleWithCampaign } from "src/utils/ssqTitle";
import { URLHandler } from "src/services/URLHandler";
import { QuestionnaireForm } from "src/components/QuestionnaireForm/layouts/QuestionnaireUpdateForm";
import { useGetOrganizationPost } from "src/api/client-api/post/useGetOrganizationPost";
import { useQuestionnaireUpdateScoresParams } from "src/components/QuestionnaireForm/useQuestionnaireUpdateScoresParams";
import { useGetOneSsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";

export const QuestionnaireUpdate = () => {
    const { ssqId: ssqIdParam, scoreId } = useParams<{ ssqId: string; campaignId: string; scoreId: string }>();
    const { currentCampaign, selectedCompany } = useFoodpilotContext();
    const { scoresParams } = useQuestionnaireUpdateScoresParams();
    const { canUser } = useFoodpilotContext();

    const ssqId = ssqIdParam ? Number(ssqIdParam) : undefined;
    const postQuery = useGetOrganizationPost({
        companyId: selectedCompany?.id,
        ssqId,
        campaignId: currentCampaign?.id,
        scoresQuery: scoresParams.query,
    });
    const { ssqVersion } = useGetOneSsqVersion(postQuery.data?.ssqVersionId);

    if (!ssqId || !selectedCompany || !currentCampaign) return <Loading />;

    return (
        <QuestionnaireFormContextProvider
            title={selectedCompany.name}
            subtitle={(ssq) => getSsqDisplayTitleWithCampaign(ssq, currentCampaign)}
            ssqVersion={ssqVersion}
            postQuery={postQuery}
            backUrl={URLHandler.company.questionnaireScore(
                selectedCompany.id,
                ssqId,
                currentCampaign.id,
                scoreId ?? "",
            )}
            getHeadingUrl={(headingId: number) =>
                URLHandler.company.questionnaireHeading(
                    selectedCompany.id,
                    ssqId,
                    currentCampaign.id,
                    scoreId ?? "",
                    headingId,
                )
            }
            canEdit={canUser(ANSWER_SSQ, ORGANIZATION)}
        >
            <QuestionnaireForm />
        </QuestionnaireFormContextProvider>
    );
};
